import { render, staticRenderFns } from "./fee_group_list.vue?vue&type=template&id=21daa9b7&scoped=true"
import script from "./fee_group_list.vue?vue&type=script&lang=js"
export * from "./fee_group_list.vue?vue&type=script&lang=js"
import style0 from "./fee_group_list.vue?vue&type=style&index=0&id=21daa9b7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21daa9b7",
  null
  
)

export default component.exports